<div class="l-top-navi">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <div class="l-top-navi__back-area">
          <!-- 戻るボタンの遷移先が他アプリ or 同一アプリ内か判定しアンカータグを切り替えている。理由は以下のとおり
             ・routerLinkで指定するパスはRouteConfigに存在しなければならない(そうでなければ実行時にエラーになる)
             ・RouteConfigには同一アプリ内のパスしか定義できない
             ・したがって、他アプリへのパスをrouterLinkで指定することはできない
             ・そこで、他アプリへの遷移はaタグのhrefにルートパスを指定することで実装し、同一アプリ内での遷移時はrouterLinkを使用して実装することにした-->
          <ng-container *ngIf="isBackToAnotherApp; else servicingFlow">
            <a id="servicing-e-ticket-emd-select-sub-header-back1" class="l-top-navi__back-link" [href]="backUrl">
              <span class="u-visually-hidden" innerHTML="{{ 'reader.goBackToPreviousPage' | staticMsg }}"></span
            ></a>
          </ng-container>
          <ng-template #servicingFlow>
            <a
              id="servicing-e-ticket-emd-select-sub-header-back2"
              class="l-top-navi__back-link"
              [routerLink]="backUrl"
              (click)="goBack()"
            >
              <span class="u-visually-hidden" innerHTML="{{ 'reader.goBackToPreviousPage' | staticMsg }}"></span
            ></a>
          </ng-template>
        </div>
        <div class="l-top-navi__heading-area">
          <!-- 遷移元によって、ヘッダータイトルを切り替える。 -->
          <h1 class="l-top-navi__heading-text" [innerHTML]="pagetitleMessageId | staticMsg"></h1>
        </div>
      </div>
    </div>
  </div>
</div>
